import request from '@/utils/request';

export function saveGain(gainEid, paraEid, data) {
    if (paraEid) {
        return request({
            url: `/gains/${gainEid}/para/${paraEid}`,
            method: 'put',
            data: data
        });
    }

    return request({
        url: `/gains/${gainEid}/para`,
        method: 'post',
        data: data
    });
}

export function deletePara(gainEid, paraEid) {
    return request({
        url: `/gains/${gainEid}/para/${paraEid}`,
        method: 'delete'
    });
}

export function getGain(gainEid, paraEid) {
    if (paraEid) {
        return request({
            url: `/gains/${gainEid}/para/${paraEid}`,
            method: 'get'
        });
    }
    return request({
        url: `/gains/${gainEid}/para`,
        method: 'get'
    });
}

export function listPara(gainEid) {
    return request({
        url: `/gains/${gainEid}/para/list`,
        method: 'get'
    });
}

export function listReviews(gainEid, batchEid) {
    return request({
        url: `/gains/${gainEid}/para/${batchEid}/reviews`,
        method: 'get'
    });
}